// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"e0789a59","36":"582065bc","67":"18fd17bb","118":"861dae56","311":"74742c50","337":"0bf96155","453":"d855a71b","495":"2ef2c554","604":"92d3a871","621":"04063fff","714":"308698ff","731":"d98567fb","794":"556f0e4f","971":"355c2f9a"}[chunkId] + ".chunk.js";
};